import LayoutPageRoot from "./layout/index";

export const routerPageRoot: any = {
  path: "/",
  element: <LayoutPageRoot />,
};
